/* eslint-disable padding-line-between-statements */
import {
  height,
  HeightProps,
  maxHeight,
  MaxHeightProps,
  maxWidth,
  MaxWidthProps,
  minHeight,
  MinHeightProps,
  minWidth,
  MinWidthProps,
  size,
  SizeProps,
  width,
  WidthProps,
} from 'styled-system';
import { css } from '~ui-kit/styled-components';
import { applyTransientProps, PrependDollar } from './styled-system-helpers';

/**
 * size
 */
export type StyledSizeProps = PrependDollar<SizeProps>;

export const styledSize = <T extends StyledSizeProps>(props: T) => applyTransientProps(props, size);

/**
 * width, min-width, max-width
 */
export type StyledWidthProps = PrependDollar<WidthProps>;
export type StyledMinWidthProps = PrependDollar<MinWidthProps>;
export type StyledMaxWidthProps = PrependDollar<MaxWidthProps>;

export const styledWidth = <T extends StyledWidthProps>(props: T) => applyTransientProps(props, width);
export const styledMinWidth = <T extends StyledMinWidthProps>(props: T) => applyTransientProps(props, minWidth);
export const styledMaxWidth = <T extends StyledMaxWidthProps>(props: T) => applyTransientProps(props, maxWidth);

/**
 * height, min-height, max-height
 */
export type StyledHeightProps = PrependDollar<HeightProps>;
export type StyledMinHeightProps = PrependDollar<MinHeightProps>;
export type StyledMaxHeightProps = PrependDollar<MaxHeightProps>;

export const styledHeight = <T extends StyledHeightProps>(props: T) => applyTransientProps(props, height);
export const styledMinHeight = <T extends StyledMinHeightProps>(props: T) => applyTransientProps(props, minHeight);
export const styledMaxHeight = <T extends StyledMaxHeightProps>(props: T) => applyTransientProps(props, maxHeight);

/**
 * Combine size, width and height props
 */
export interface StyledSizingProps
  extends StyledSizeProps,
    StyledHeightProps,
    StyledMinHeightProps,
    StyledMaxHeightProps,
    StyledWidthProps,
    StyledMinWidthProps,
    StyledMaxWidthProps {}

export const styledSizing = css<StyledSizingProps>`
  ${styledSize}
  ${styledWidth}
  ${styledMinWidth}
  ${styledMaxWidth}
  ${styledHeight}
  ${styledMinHeight}
  ${styledMaxHeight}
`;
